import { getTaskCheckOption, primaryGoalId } from '@griply/utils';
import { ID } from 'shared/types/id';
import { Task } from 'shared/types/task';
import { TaskCardTask } from 'shared/types/task-card-task';
import { Timestamp } from 'shared/types/timestamp';
import { initialWeekStartsOn, WeekDays } from 'shared/types/week-days';

import { getTaskCompletedState } from '../get-task-completed-state';
import { getTaskDueDate } from '../get-task-due';

type Options = {
  today: Timestamp;
  weekStartsOn: WeekDays;
  showRepeatingAsTodo?: boolean;
  customId?: ID;
  showDue?: boolean | ((task: Task) => boolean);
};

export const mapTaskToTaskCard = (
  task: Task,
  {
    weekStartsOn,
    today,
    showRepeatingAsTodo,
    customId,
    showDue: showDueFn,
  }: Options,
): TaskCardTask => {
  weekStartsOn = weekStartsOn ?? initialWeekStartsOn;

  const showDue =
    typeof showDueFn === 'function' ? showDueFn(task) : !!showDueFn;
  const dueDate = showDue
    ? getTaskDueDate(task, {
        today,
        weekStartsOn,
      })
    : undefined;

  return {
    id: customId ?? task.id,
    checked: getTaskCheckOption(task, {
      day: today,
      today,
      showRepeatingAsTodo,
      weekStartsOn,
    }),
    strikeThrough: getTaskCompletedState(task, today, showRepeatingAsTodo),
    raw: {
      dueDate,
      task,
    },
    fields: {
      name: task.name,
      type: task.type,
      schedules: task.schedules ?? undefined,
      reminderTime: task.reminderTime ?? undefined,
      reminders: task.reminders ?? null,
      goalId: primaryGoalId(task) ?? undefined,
      priority: task.priority ?? undefined,
      endStrategy: {
        deadline: task.endStrategy?.deadline ?? undefined,
        completionCount: task.endStrategy?.completionCount ?? undefined,
      },
    },
    isFrozen: !!task.frozenAt,
  };
};
